module.exports = __webpack_public_path__ + "static/media/people_laptop.5a9b3eef.jpg";